// 用户登录授权信息
export const SET_USER_TOKEN = 'SET_USER_TOKEN';
export const CLEAR_USER_TOKEN = 'CLEAR_USER_TOKEN';
export const SET_USER_INFO = 'SET_USER_INFO';
export const CLEAR_USER_INFO = 'CLEAR_USER_INFO';
export const SET_ORDERS = 'SET_ORDERS';
